import { CommerceToolNames } from '../hooks/toolStatus/useCommerceToolStatus';
const toolNameToTrackingPrefix = {
  [CommerceToolNames.invoices]: 'invoices',
  [CommerceToolNames.paymentLinks]: 'payment_links',
  [CommerceToolNames.quotes]: 'quotes',
  [CommerceToolNames.subscriptions]: 'subscriptions'
};

/**
 * Converts tool usage data into tracking status strings
 * @param toolUsage Record of tool names and their status
 * @returns Array of tracking status strings (e.g. ['payment_link_pre_tool', 'invoice_post_tool'])
 */
export const getToolTrackingStatus = toolUsage => {
  const toolStatus = [];
  if (toolUsage) {
    Object.entries(toolUsage).forEach(([tool, status]) => {
      toolStatus.push(`${toolNameToTrackingPrefix[tool]}_${status}`);
    });
  }
  return toolStatus;
};